import type { CartItemType } from '@/types'

export function collectProductIds(products?: CartItemType[]): string[] {
  if (!products?.length) {
    return []
  }

  const productIds = products
    .map(product => product?.productId)
    .filter((id): id is string => typeof id === 'string' && id.length > 0)

  return Array.from(new Set(productIds))
}
